import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { ErrorMessage } from '@sdir/utilities/lib/components';
import { SidResponseVerify } from '@sdir/httpclient/lib/clients/aps/personalcertificate';
import { sidVerifyApi } from '../../../httpclient';
import Sid from '../../Organisms/Sid';

const SidPage: React.FC = () => {
  const { uid } = useParams<{ uid: string }>();
  const [searchError, setSearchError] = useState(null);
  const [sid, setSid] = useState<SidResponseVerify>();

  useEffect(() => {
    sidVerifyApi
      .v1SeafareridentitydocumentGetbyidverifyDocumentNumberGet(uid)
      .then((response) => {
        if (response.status === 200) {
          setSid(response.data);
        }
      })
      .catch((error) => {
        setSearchError(error);
        setSid(undefined);
      });
  }, [uid]);

  return (
    <Wrapper>
      {sid && <Sid sid={sid} />}
      {searchError && <ErrorMessage error={searchError} />}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-top: 2em;
`;

export default SidPage;
